import * as React from 'react';
import { useCountDown, usePhoneValue, useSendVerificationCode, useVerificationStep, useVerifyValue } from './utils';
import { EPhoneVerificationStep } from './constants';
import { PhoneField, VerifyField } from '../../components/PhoneVerification/components';
import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { QuestionLayoutContainer } from '../QuestionLayoutContainer';

export const PhoneVerificationContainer: React.FC<IBaseQuestionProps> = props => {
  const { value: phone, onChange: onChangePhone, isValid: isPhoneValid, onSubmit } = usePhoneValue(props);
  const { seconds: countDown, start: startCountDown } = useCountDown();
  const { value: verificationCode, onChange: onChangeVerify, isValid: isVerifyValid } = useVerifyValue('');
  const { gotToPhoneStep, goToVerificationStep, step, title } = useVerificationStep();
  const { isFetching, error: requestError, sendVerificationCode, sendVerificationSms } = useSendVerificationCode({
    verificationCode,
    phone,
    startCountDown,
    onVerifySuccess: onSubmit,
    onSendSmsSuccess: goToVerificationStep,
  });

  return (
    <QuestionLayoutContainer title={title}>
      {step === EPhoneVerificationStep.PHONE ? (
        <PhoneField
          error={requestError}
          fetching={isFetching}
          value={phone}
          onChange={onChangePhone}
          isValid={isPhoneValid}
          onSubmit={sendVerificationSms}
        />
      ) : (
        <VerifyField
          fetching={isFetching}
          seconds={countDown}
          restart={sendVerificationSms}
          phone={phone}
          value={verificationCode}
          error={requestError}
          isValid={isVerifyValid}
          onChange={onChangeVerify}
          onSubmit={sendVerificationCode}
          onChangePhone={gotToPhoneStep}
        />
      )}
    </QuestionLayoutContainer>
  );
};

PhoneVerificationContainer.displayName = 'PhoneVerificationContainer';
